import ErrorBoundary from "../ErrorBoundary";
import Footer from "../Footer";
import Header from "../Header";
import React, {useEffect} from "react";
import SetNoIndex from "../../lib/SetNoIndex";
import styles from "./DuplicatePage.module.css";
import TextLink from "../TextLink";
import usePageView from "../../lib/usePageView";
import {Container, Row, Column} from "../grid";

const strings = {
    title: "1st Financial Bank USA Card Duplicate Request",
    header: "Duplicate Application",
    p1:
        "This application cannot be submitted because it contains the same Social Security number contained in an application we received within the previous 60 days.",
    p2:
        "Notice of the action taken on the previously submitted application has been or will be provided to you by mail.",
    p3:
        "If you believe that this message was sent to you in error, please contact our support team at ",
    phone: "1-800-733-1732.",
};

export default function DuplicatePage() {
    useEffect(() => {
        document.title = strings.title;
    }, []);

    SetNoIndex();
    usePageView(strings.title);

    return (
        <ErrorBoundary>
            <Header />
            <Container className={styles.container}>
                <Row className={styles.titleRow}>
                    <Column>
                        <h1 className={styles.title}>{strings.header}</h1>
                    </Column>
                </Row>
                <Row className={styles.p1Row}>
                    <Column>
                        <div className={styles.paragraph}>{strings.p1}</div>
                    </Column>
                </Row>
                <Row className={styles.p2Row}>
                    <Column>
                        <div className={styles.paragraph}>{strings.p2}</div>
                    </Column>
                </Row>
                <Row className={styles.p3Row}>
                    <Column>
                        <div className={styles.paragraph}>
                            {strings.p3}
                            <TextLink
                                openInSameTab={true}
                                className={styles.link}
                                href="tel:800-733-1732"
                                text={strings.phone}
                            />
                        </div>
                    </Column>
                </Row>
            </Container>
            <Footer />
        </ErrorBoundary>
    );
}
